import { useEffect } from 'react'

interface Props {
  currentStep: number
}

const useScroll = ({
  currentStep
}: Props) => {

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [currentStep])

}

export default useScroll